import { Pagination } from "@mui/material";
import {
  ArchiveIcon,
  AvatarIcon,
  CalendarIcon,
  CheckCircledIcon,
  Cross2Icon,
  CrossCircledIcon,
  HomeIcon,
  Pencil1Icon,
  PersonIcon,
  SewingPinFilledIcon,
} from "@radix-ui/react-icons";
import { Loader2, Repeat } from "lucide-react";
import { useEffect, useState } from "react";
import toast from "react-hot-toast";
import { useNavigate, useParams } from "react-router-dom";
import { checkTagValidity, getUserProfil, HOME } from "../../Utils/Utils";
import {
  BASE_URL,
  EDIT_INTENTION_PBO,
  EXPORT_RAPPORT,
  LIST_SURVEY,
  LISTE_BRIN_DISPO,
  LISTE_PBO_DISPO,
  STATS_COUNTER_SURVEY,
  TYPE_RENDEZ_VOUS,
} from "../../Utils/constant";
import { UpdateRdv } from "../../components/Abonnement/UpdateRdv";
import { UpdateSurvey } from "../../components/Ajouter-intention/UpdateSurvey";
import { Calendar } from "../../components/Icons/Calendar";
import { List } from "../../components/Icons/List";
import { Counter } from "../../components/Stats/Counter";
import { ContentLoading } from "../../components/Widget/ContentLoading";
import { Pbo } from "../../components/Widget/Pbo";
import { Periode } from "../../components/Widget/Periode";
import { Tabs } from "../../components/Widget/Tab";
import { find, store } from "../../services/service";
import { useCommentaireStore } from "../../store/CommentaireStore";
import { useStoreStats } from "../../store/StatsStore";
import { useStoreSurvey } from "../../store/SurveyStore";
import { useStoreApp } from "../../store/storeApp";
import { UpdateNumeroFtth } from "./UpdateNumFtth";

const Survey = () => {
  const { status } = useParams();
  const [numeroTicket, setNumeroTicket] = useState(null);
  const [dateRange, setDateRange] = useState([null, null]);
  const [submited, setSubmited] = useState(false);
  const [selectedBrin, setSelectedBrin] = useState(null);
  const [selectedPbo, setSelectedPbo] = useState(null);
  const [select, setSelect] = useState("ANNEE");
  const [active, setActive] = useState({
    index: status === "OK" ? 1 : 0,
    value: "",
  });
  const [msg, setMsg] = useState("");
  const [selectItem, setSelectItem] = useState(null);
  const [listePbo, setListePbo] = useState([]);
  const [listeBrin, setListeBrin] = useState([]);
  const [loadingPbo, setLoadingPbo] = useState(false);
  const [loadingBrin, setLoadingBrin] = useState(false);
  const navigate = useNavigate();
  const [isDeleting, setIsDeleting] = useState(false);
  const [motif, setMotif] = useState("");

  const getListePbo = async (latitude, longitude) => {
    setLoadingPbo(true);
    setListePbo([]);
    setListeBrin([]);
    setSelectedPbo("");
    setSelectedBrin("");

    try {
      const res = await find(
        LISTE_PBO_DISPO + `?latitude=${latitude}&longitude=${longitude}`,
      );
      setListePbo(res?.data?.donnee || []);
    } catch (error) {
      setMsg(error?.response?.data?.donnee);
      setListePbo([]);
    } finally {
      setLoadingPbo(false);
    }
  };

  const getListBrin = async (pbo) => {
    setLoadingBrin(true);
    setListeBrin([]);
    setSelectedBrin("");

    try {
      const res = await find(`${LISTE_BRIN_DISPO}/${pbo}`);
      setListeBrin(res?.data?.donnee || []);
    } catch (error) {
      toast.error("Erreur lors du chargement des brins");
      setListeBrin([]);
    } finally {
      setLoadingBrin(false);
    }
  };

  const moreEnAttente = (page) => {
    survey.getData(
      `${TYPE_RENDEZ_VOUS}?page=${
        page - 1
      }&param=&size=8&dateDebut=&dateFin=&statutAbonnement=EN_ATTENTE_DE_SURVEY&statutPriseEnCharge=&resultat=&typeRdv=SURVEY&inTime=`,
    );
  };

  const verifyBrin = async (item) => {
    const res = await find(
      `/commerciale/brin/verifier-brin-abonnement?numeroTicket=${item?.abonnement?.eligibilite?.numeroTicket}`,
    );
    if (item?.brin !== null || res.data.donnee === true) {
      navigate(
        `${HOME}/servey/poursuivre-intention/${item?.abonnement?.eligibilite?.numeroTicket}/6`,
      );
    } else {
      document.getElementById("modalNoBrin").showModal();
    }
  };

  const more = (page) => {
    storeData.getData(
      LIST_SURVEY,
      { page: page - 1, param: "", size: 6 },
      `&periode=&mois=&annee=&dateDebut=&dateFin=&status=REALISER&resultat=OK`,
    );
  };

  const storeData = useStoreApp();
  const statsData = useStoreStats();
  const survey = useStoreSurvey();
  const commentaire = useCommentaireStore();

  const listeTabsData = [
    {
      index: 0,
      value: "En attente de survey",
      tag: "LISTE_EN_ATTENTE_SURVEY",
    },
    {
      index: 1,
      value: "Survey realisé",
      tag: "LISTE_SURVEY",
    },
  ];

  const filteredTabsData = listeTabsData
    .filter((tab) => checkTagValidity(tab.tag))
    .map((tab, index) => ({ ...tab, index }));

  useEffect(() => {
    if (filteredTabsData.length !== 0) {
      setActive(filteredTabsData[status === "OK" ? 1 : 0]);
    }
    commentaire.getData("page=0&param=&size=10000000");
    survey.getData(
      `${TYPE_RENDEZ_VOUS}?page=0&param=&size=8&dateDebut=&dateFin=&statutAbonnement=EN_ATTENTE_DE_SURVEY&statutPriseEnCharge=&resultat=&typeRdv=SURVEY&inTime=`,
    );
    statsData.getData(
      `${STATS_COUNTER_SURVEY}?periode=ANNEE&typeRdv=SURVEY&mois=&annee=${new Date().getFullYear()}&dateDebut=&dateFin=`,
    );
    storeData.getData(
      LIST_SURVEY,
      { page: 0, param: "", size: 6 },
      `&periode=&mois=&annee=&dateDebut=&dateFin=&status=REALISER&resultat=OK&inTime=`,
    );
  }, []);

  const handleDownload = () => {
    const user = getUserProfil();
    fetch(
      `${BASE_URL + EXPORT_RAPPORT}?model=SURVEYS&username=${user?.username}`,
      {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify({}),
      },
    )
      .then((response) => response.blob())
      .then((blob) => {
        const url = window.URL.createObjectURL(blob);
        const a = document.createElement("a");
        a.style.display = "none";
        a.href = url;
        a.download = `RAPPORT_SURVEYS.xlsx`; // spécifiez le nom du fichier et son extension
        document.body.appendChild(a);
        a.click();
      })
      .catch((err) => console.error("Erreur de téléchargement:", err));
  };

  const Submit = async (e) => {
    e.preventDefault();

    if (!selectedPbo || !selectedBrin) {
      toast.error("Veuillez sélectionner un PBO et un Brin");
      return;
    }

    setSubmited(true);
    setMsg("");

    try {
      await store(
        EDIT_INTENTION_PBO +
          `/${selectItem?.abonnement?.id}/${selectedPbo}/${selectedBrin}`,
        "application/json",
        {},
      );
      survey.getData(
        `${TYPE_RENDEZ_VOUS}?page=0&param=&size=8&dateDebut=&dateFin=&statutAbonnement=EN_ATTENTE_DE_SURVEY&statutPriseEnCharge=&resultat=&typeRdv=SURVEY&inTime=`,
      );
      setSelectedBrin("");
      setSelectedPbo("");
      setListePbo([]);
      setListeBrin([]);
      setMsg("");
      document.getElementById("edit").close();
      toast.success("Modification effectuée avec succès");
    } catch (err) {
      const errorMsg =
        err?.response?.data?.donnee || "Erreur lors de la modification";
      setMsg(errorMsg);
    } finally {
      setSubmited(false);
    }
  };

  return (
    <div className="">
      <dialog id="editFtth" className="modal rounded-none">
        <div className="modal-box">
          <div className="modal-action">
            <h1 className="mr-auto text-2xl font-bold font-mtn">
              Modification
            </h1>
            <form method="dialog">
              <button id="detail" className="btn btn-sm">
                <Cross2Icon />
              </button>
            </form>
          </div>
          <UpdateNumeroFtth item={selectItem} />
        </div>
      </dialog>
      {/* Modal Modifier PBO/Brin */}
      <dialog id="edit" className="modal">
        <div className="modal-box max-w-xl">
          <div className="modal-action">
            <h1 className="mr-auto text-2xl font-bold font-mtn">
              Modification de l'abonnement
            </h1>

            {msg && (
              <div className="mb-3">
                <span className="text-red-500 text-sm">{msg}</span>
              </div>
            )}

            <form method="dialog">
              <button
                id="fermer"
                className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-100 hover:bg-red-200 text-red-600 hover:text-red-600 font-semibold"
                onClick={() => {
                  setListePbo([]);
                  setListeBrin([]);
                  setSelectedPbo("");
                  setSelectedBrin("");
                  setMsg("");
                }}
              >
                ✕
              </button>
            </form>
          </div>

          {msg && (
            <div className="alert alert-error mb-3">
              <span className="text-sm">{msg}</span>
            </div>
          )}

          <form onSubmit={Submit}>
            <div className="my-3 space-y-4">
              {/* Select PBO avec chargement */}
              <div>
                <label className="text-sm font-medium block mb-2">PBO</label>
                <div className="relative">
                  <select
                    className="select select-bordered w-full"
                    value={selectedPbo}
                    onChange={(e) => {
                      setSelectedPbo(e.target.value);
                      if (e.target.value) {
                        getListBrin(e.target.value);
                      } else {
                        setListeBrin([]);
                        setSelectedBrin("");
                      }
                    }}
                    disabled={loadingPbo || submited}
                  >
                    <option value="">
                      {loadingPbo
                        ? "Chargement des PBO..."
                        : "-- Sélectionner un PBO --"}
                    </option>
                    {listePbo?.map((pbo) => (
                      <option key={pbo.id} value={pbo.id}>
                        {pbo.nom}
                      </option>
                    ))}
                  </select>
                  {loadingPbo && (
                    <div className=" absolute right-12 top-1/2 -translate-y-1/2">
                      <Loader2 className="w-4 h-4 animate-spin text-gray-400" />
                    </div>
                  )}
                </div>
                {!loadingPbo && listePbo?.length === 0 && (
                  <p className="text-xs text-gray-500 mt-1">
                    Aucun PBO disponible
                  </p>
                )}
              </div>

              {/* Select Brin avec chargement */}
              <div>
                <label className="text-sm font-medium block mb-2">Brin</label>
                <div className="relative">
                  <select
                    className="select select-bordered w-full"
                    value={selectedBrin}
                    onChange={(e) => setSelectedBrin(e.target.value)}
                    disabled={!selectedPbo || loadingBrin || submited}
                  >
                    <option value="">
                      {!selectedPbo
                        ? "Sélectionnez d'abord un PBO"
                        : loadingBrin
                          ? "Chargement des brins..."
                          : "-- Sélectionner un Brin --"}
                    </option>
                    {listeBrin?.map((brin) => (
                      <option key={brin.id} value={brin.id}>
                        {brin.designation}
                      </option>
                    ))}
                  </select>
                  {loadingBrin && (
                    <div className=" absolute right-12 top-1/2 -translate-y-1/2">
                      <Loader2 className="w-4 h-4 animate-spin text-gray-400" />
                    </div>
                  )}
                </div>
                {!loadingBrin && selectedPbo && listeBrin?.length === 0 && (
                  <p className="text-xs text-gray-500 mt-1">
                    Aucun brin disponible pour ce PBO
                  </p>
                )}
              </div>

              {/* Bouton de soumission */}
              <div className="pt-3">
                <button
                  type="submit"
                  disabled={
                    submited ||
                    !selectedBrin ||
                    !selectedPbo ||
                    loadingPbo ||
                    loadingBrin
                  }
                  className={`btn btn-sm ${
                    submited ||
                    !selectedBrin ||
                    !selectedPbo ||
                    loadingPbo ||
                    loadingBrin
                      ? "btn-disabled opacity-50"
                      : "bg-main text-black border-main hover:bg-opacity-90"
                  }`}
                >
                  {submited ? (
                    <>
                      <Loader2 className="w-4 h-4 animate-spin" />
                      Enregistrement...
                    </>
                  ) : (
                    "Mettre à jour"
                  )}
                </button>
              </div>
            </div>
          </form>
        </div>
      </dialog>
      <div className="lg:flex gap-8 items-center">
        <h3 class="font-mtn text-3xl font-bold">Survey</h3>
        {/* <div className="ml-auto flex gap-x-3">
          <select
            onChange={(e) => {
              setSelect(e.target.value);
            }}
            className="my-2 select"
          >
            <option>Periode</option>
            <option value="MOIS">Filtre par mois</option>
            <option value="ANNEE" selected>
              Filtre par années
            </option>
          </select>
          {select === "MOIS" ? (
            <select
              onChange={(e) => {
                survey.getData(
                  `${SURVEY_PAR_TYPE}?page=0&param=&size=8&periode=${select}&mois=${
                    e.target.value
                  }&annee=${new Date().getFullYear()}&dateDebut=&dateFin=&status=EN_ATTENTE&resultat=&typeRdv=SURVEY`
                );
                statsData.getData(
                  `${STATS_COUNTER_SURVEY}?periode=${select}&typeRdv=SURVEY&mois=${
                    e.target.value
                  }&annee=${new Date().getFullYear()}&dateDebut=&dateFin=`
                );
              }}
              className="my-2 select"
            >
              <option disabled selected>
                mois
              </option>
              {months.map((item) => (
                <option value={item.code}>{item.name}</option>
              ))}
            </select>
          ) : select === "ANNEE" ? (
            <select
              onChange={(e) => {
                survey.getData(
                  `${SURVEY_PAR_TYPE}?page=0&param=&size=8&periode=ANNEE&mois=&annee=${e.target.value}&dateDebut=&dateFin=&status=EN_ATTENTE&resultat=&typeRdv=SURVEY`
                );
                statsData.getData(
                  `${STATS_COUNTER_SURVEY}?periode=ANNEE&typeRdv=SURVEY&mois=&annee=${e.target.value}&dateDebut=&dateFin=`
                );
              }}
              className="my-2 select "
            >
              <option disabled selected>
                années
              </option>
              {years.map((item) => (
                <option
                  value={item.name}
                  selected={
                    new Date().getFullYear() === Number(item.name)
                      ? true
                      : false
                  }
                >
                  {item.name}
                </option>
              ))}
            </select>
          ) : (
            <ReactDatePicker
              dateFormat="dd-MM-yyyy"
              selected={startDate}
              onChange={(update) => {
                if (update[1] != null) {
                  survey.getData(
                    `${SURVEY_PAR_TYPE}?page=0&param=&size=8&periode=JOUR&mois=&annee=&&dateDebut=${update[0]
                      ?.toLocaleDateString()
                      .replace(/\//g, "-")}&dateFin=${update[1]
                      ?.toLocaleDateString()
                      .replace(
                        /\//g,
                        "-"
                      )}&status=EN_ATTENTE&resultat=&typeRdv=SURVEY`
                  );
                  statsData.getData(
                    `${STATS_COUNTER_SURVEY}?periode=JOUR&typeRdv=SURVEY&mois=&annee=&dateDebut=${update[0]
                      ?.toLocaleDateString()
                      .replace(/\//g, "-")}&dateFin=${update[1]
                      ?.toLocaleDateString()
                      .replace(/\//g, "-")}`
                  );
                }
                setDateRange(update);
              }}
              startDate={startDate}
              endDate={endDate}
              selectsRange
              className="text-xs font-normal cursor-pointer btn btn-sm hover:bg-gray-100 text-center h-8 my-2 w-52 rounded-md border border-input bg-gray-100 px-3 py-1 shadow-sm"
            />
          )}
        </div> */}
      </div>

      <div className="mt-4 grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3 gap-3">
        <Counter
          icon={
            <div className="text-black ">
              <List />
            </div>
          }
          color={"bg-[#d8e2fc]"}
          label={"Survey en attente"}
          count={statsData?.data?.stats?.totalEnAttente}
          text={`Rapport  ${select.toLocaleLowerCase()} ${
            statsData?.data?.rapport?.totalRapportEnAttente ?? "--"
          }`}
        />
        <Counter
          icon={
            <div className="text-black ">
              <Calendar />
            </div>
          }
          color={"bg-[#f9e0e1]"}
          label={"Survey realisé"}
          count={statsData?.data?.stats?.totalOk}
          text={`Rapport ${select.toLocaleLowerCase()} ${
            statsData?.data?.rapport?.totalRapportOk ?? "--"
          }`}
        />
        <Counter
          icon={
            <div className="text-black ">
              <List />
            </div>
          }
          color={"bg-[#f9e0e1]"}
          label={"Survey realisé Non OK"}
          count={statsData?.data?.stats?.totalNonOk}
          text={`Rapport ${select.toLocaleLowerCase()} ${
            statsData?.data?.rapport?.totalRapportNonOk ?? "--"
          }`}
        />
      </div>

      {filteredTabsData.length !== 0 ? (
        <Tabs
          tabsData={filteredTabsData}
          active={active}
          setActive={setActive}
        />
      ) : null}
      <div className="bg-white rounded-md px-2 py-4 mt-3">
        <div className="mt-3 lg:flex items-center gap-2">
          {active.index === 1 ? (
            <>
              <input
                type="text"
                onChange={(e) => {
                  storeData.getData(
                    LIST_SURVEY,
                    { page: 0, param: e.target.value, size: 6 },
                    `&periode=&mois=&annee=&dateDebut=&dateFin=&status=REALISER&resultat=OK&inTime=`,
                  );
                }}
                placeholder="Rechercher element..."
                className="text-xs input input-bordered px-3 w-80 h-10 text-gray-900 placeholder:text-gray-400"
              />
              <select
                onChange={(e) => {
                  storeData.getData(
                    LIST_SURVEY,
                    { page: 0, param: "", size: 6 },
                    `&periode=&mois=&annee=&dateDebut=&dateFin=&status=REALISER&resultat=${e.target.value}&inTime=`,
                  );
                }}
                className="select"
              >
                <option disabled>Resultat</option>
                <option value="OK" selected>
                  OK
                </option>
                <option value="NON_OK">Non OK</option>
                <option value="PARTIALY_OK">Partialy OK</option>
              </select>

              <button
                className="btn btn-sm bg-main text-black"
                onClick={handleDownload}
              >
                Exporter
              </button>
            </>
          ) : (
            <div className="flex items-center gap-2">
              <input
                type="text"
                onChange={(e) => {
                  survey.getData(
                    `${TYPE_RENDEZ_VOUS}?page=0&param=${e.target.value}&size=8&dateDebut=&dateFin=&statutAbonnement=EN_ATTENTE_DE_SURVEY&statutPriseEnCharge=&resultat=&typeRdv=SURVEY&inTime=`,
                  );
                }}
                placeholder="Rechercher element..."
                className="text-xs input input-bordered px-3 w-80 h-10 text-gray-900 placeholder:text-gray-400"
              />
              <select
                onChange={(e) =>
                  survey.getData(
                    `${TYPE_RENDEZ_VOUS}?page=0&param=&size=8&dateDebut=&dateFin=&statusAbonnement=EN_ATTENTE_DE_SURVEY&statutPriseEnCharge=&resultat=&typeRdv=SURVEY&inTime=${e.target.value}`,
                  )
                }
                className="select pl-non my-3"
              >
                <option disabled selected>
                  Delais de traitement
                </option>
                <option value="">Tout afficher</option>
                <option value={"true"}>Intention dans le delais</option>
                <option value={"false"}>Intention hors delais</option>
              </select>
            </div>
          )}
        </div>
        <dialog id="delete-intention" className="modal">
          <div className="modal-box max-w-md bg-white rounded-2xl shadow-2xl">
            <div className="text-center p-6">
              <div className="mx-auto w-16 h-16 bg-red-100 rounded-full flex items-center justify-center mb-4">
                <Repeat className="h-8 w-8 text-red-600" />
              </div>
              <h3 className="text-xl font-bold text-gray-900 mb-2">
                Retourner l'abonnement
              </h3>
              <p className="text-gray-600 mb-6 text-xs">
                Êtes-vous sûr de vouloir retourner cet abonnement ? Cette action
                est irréversible et nécessitera une nouvelle prise en charge de
                la part de l'équipe commerciale. Veuillez fournir un motif pour
                cette action.
              </p>

              <div>
                <p className="text-left text-sm my-2">Motif de retour</p>
                <textarea
                  value={motif}
                  onChange={(e) => setMotif(e.target.value)}
                  className="w-full border border-gray-300 rounded-lg p-2 mb-4"
                  rows={3}
                  placeholder="Entrez le motif de retour ici..."
                ></textarea>
              </div>
              <div className="flex items-center justify-center gap-3">
                <form method="dialog">
                  <button
                    onclick={() => setMotif("")}
                    className="text-xs px-6 py-3 text-gray-600 bg-gray-100 hover:bg-gray-200 rounded-lg font-medium transition-all duration-200"
                  >
                    Annuler
                  </button>
                </form>
                <button
                  onClick={() => {
                    setIsDeleting(true);
                    store(
                      `commerciale/retour-abonnements/retourner/${selectItem?.id}?motif=${motif}`,
                      "application/json",
                      {},
                    )
                      .then(() => {
                        document.getElementById("delete-intention").close();
                        survey.getData(
                          `${TYPE_RENDEZ_VOUS}?page=0&param=&size=8&dateDebut=&dateFin=&statutAbonnement=EN_ATTENTE_DE_SURVEY&statutPriseEnCharge=&resultat=&typeRdv=SURVEY&inTime=`,
                        );
                        toast.success("Abonnement retourné avec succès");
                      })
                      .catch((err) => {
                        toast.error(
                          err?.response?.data?.donnee ||
                            "Erreur lors du retour de l'abonnement",
                        );
                      })
                      .finally(() => {
                        setIsDeleting(false);
                        const dlg = document.getElementById("delete-intention");
                        if (dlg) dlg.close();
                      });
                  }}
                  disabled={isDeleting}
                  className={`px-6 py-3 rounded-lg font-medium text-xs transition-all duration-200 flex items-center gap-2 ${
                    isDeleting
                      ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                      : "bg-red-600 hover:bg-red-700 text-white"
                  }`}
                >
                  {isDeleting ? (
                    <div className="h-4 w-4 border-2 border-white/30 border-t-white rounded-full animate-spin" />
                  ) : (
                    <Repeat className="h-4 w-4" />
                  )}
                  {isDeleting ? "Retour..." : "Retourner l'abonnement"}
                </button>
              </div>
            </div>
          </div>
        </dialog>
        {active.index === 0 ? (
          <>
            <div className=" grid lg:grid-cols-3 md:grid-cols-3 sm:grid-cols-2 mt-4 grid-cols-1 gap-5">
              {survey?.data?.data?.length === 0 ? (
                <div className="">
                  <p className="text-sm ">Aucune donnée </p>
                </div>
              ) : survey?.data?.data?.length !== 0 && !survey?.loading ? (
                survey?.data?.data?.map((item) => (
                  <div
                    className={`${
                      !item?.inTime
                        ? "border-red-300 border-2 border-dashed"
                        : "border-slate-200 border"
                    } relative ${
                      item?.statusSuppression === "EN_ATTENTE" && "opacity-30"
                    }  bg-white rounded-xl  shadow-sm`}
                  >
                    <div className="rounded-t-xl flex items-center gap-3 border-b border-dashed border-amber-400 px-2 py-3">
                      <p className="text-[12px] font-semibold">
                        N° {item?.abonnement?.eligibilite?.numeroTicket}
                      </p>
                      <div className="ml-auto flex items-center gap-2">
                        <button
                          onClick={() => {
                            setSelectItem(item);
                            document
                              .getElementById("delete-intention")
                              .showModal();
                          }}
                          className="px-2 py-1 flex items-center gap-2 text-xs text-red-600 bg-red-100 rounded hover:bg-red-200 transition-all duration-200"
                        >
                          <Repeat size={18} />
                          Retourner
                        </button>
                      </div>
                      <div className="ml-auto flex items-center gap-2"></div>
                    </div>
                    <div className=" px-3 py-2 ">
                      <div className="items-center gap-2 space-y-3">
                        <Periode item={item} />
                        <Pbo
                          pbo={item?.abonnement?.eligibilite?.pbo?.nom}
                          port={item?.brin}
                        />
                        <div className="flex gap-1 my-3">
                          <PersonIcon className="bg-gray-100 rounded-full w-8 h-8 p-2" />
                          <div>
                            <p className="text-[13px] font-medium">
                              {item?.abonnement?.client?.nomPrenoms}
                            </p>
                            <p className="text-xs flex font-semibold gap-2">
                              <span>{item?.abonnement.client?.numero}</span>{" "}
                              {" | "}{" "}
                              <span>
                                {item?.abonnement.client?.secondNumero}
                              </span>{" "}
                            </p>
                          </div>
                        </div>
                        <div className="flex gap-2">
                          <div className="animate-pulse border-dashed border w-fit px-1 py-[2px] bg-red-50 text-red-800 border-red-600 rounded">
                            <p className="text-xs flex gap-1 items-center font-medium">
                              <CalendarIcon />
                              {item?.dateRdv +
                                " de " +
                                item?.crenau?.heureDebut +
                                " à " +
                                item?.crenau?.heureFin}
                            </p>
                          </div>

                          {item?.status === "EN_ATTENTE" ? (
                            <button
                              onClick={() => {
                                document.getElementById("editrdv").showModal();
                              }}
                              className="btn btn-xs btn-ghost text-xs font-normal underline"
                            >
                              Modifier la date
                            </button>
                          ) : null}
                        </div>

                        <h1 className="text-xs flex gap-1 items-center my-2">
                          Forfait : {item?.abonnement?.forfait?.designation} -{" "}
                          {item?.abonnement?.forfait?.categorie
                            ?.replace("_", "")
                            .toLowerCase()}
                        </h1>

                        <div className=" gap-1 ">
                          <div>
                            <p className="text-[13px] font-medium">
                              Numero FTTH : {item?.abonnement?.numeroFtth}
                            </p>
                            <p className="text-xs flex font-semibold gap-2">
                              SN : <span>{item?.abonnement?.numeroSerie}</span>
                            </p>
                          </div>
                        </div>

                        <h1 className="text-xs flex gap-1 items-center my-2">
                          <AvatarIcon />
                          Equipe en charge : {item?.equipe?.designation || "--"}
                        </h1>
                        {item?.prestataire?.designation ? (
                          <h1 className="text-xs flex gap-1 p-1 w-fit rounded items-center my-2">
                            Prestataire : {item?.prestataire?.designation}
                          </h1>
                        ) : (
                          <h1 className="text-xs flex gap-1 bg-gray-300 p-1 w-fit rounded items-center my-2">
                            En attente d'attribution à un prestataire
                          </h1>
                        )}

                        {item.commentaire ? (
                          <div className="dropdown flex items-center">
                            <p className="text-xs">
                              Commentaire: {item?.commentaire}{" "}
                            </p>
                          </div>
                        ) : null}
                        <div className="pb-3 pt-1 border-b flex gap-4 items-center">
                          <p className="text-xs flex gap-1 items-center font-medium">
                            <HomeIcon />
                            {item?.abonnement?.batiment?.designation}
                          </p>
                          <p className="text-xs flex gap-1 font-medium">
                            <ArchiveIcon />{" "}
                            {item?.abonnement?.equipement?.designation}{" "}
                          </p>
                        </div>
                      </div>
                      <h1 className="my-2 text-[13px] font-medium flex items-center">
                        <SewingPinFilledIcon />
                        {item?.abonnement?.commune +
                          ", " +
                          item?.abonnement?.quartier}
                      </h1>
                      <div className="flex items-center gap-1">
                        <h5 className="text-xs font-medium ">Etape:</h5>
                        <p className=" bg-blue-50 text-blue-900 py-1 px-1 rounded-lg font-medium text-xs truncate">
                          {item?.abonnement?.status
                            ?.toLowerCase()
                            .replace(/_/g, " ")}
                        </p>
                      </div>

                      <div className="flex items-center gap-1">
                        {checkTagValidity("POURSUIVRE_SURVEY") &&
                        item?.statusSuppression !== "EN_ATTENTE" &&
                        item?.prestataire !== null ? (
                          <button
                            className="btn btn-sm bg-main my-3 font-mtn text-xs font-regular"
                            onClick={() => {
                              verifyBrin(item);
                            }}
                          >
                            Poursuivre
                          </button>
                        ) : null}
                        {/* Modal d'alerte si pas de brin */}
                        <dialog id="modalNoBrin" className="modal">
                          <div className="modal-box">
                            <h3 className="font-bold text-lg text-red-500">
                              Aucun brin trouvé
                            </h3>
                            <p className="py-4 text-sm">
                              Aucun brin n'est associé à cet abonnement.
                              Veuillez vérifier le brin avant de poursuivre.
                              <br />
                            </p>
                            <form method="dialog" className="modal-action">
                              <button className="btn">Fermer</button>
                            </form>
                          </div>
                        </dialog>
                        <button
                          onClick={() => {
                            setSelectItem(item);
                            getListePbo(
                              item?.abonnement?.eligibilite?.latitude,
                              item?.abonnement?.eligibilite?.longitude,
                            );
                            setMsg("");
                            document.getElementById("edit").showModal();
                          }}
                          className="ml-auto text-white text-xs btn btn-sm bg-black"
                        >
                          <Pencil1Icon /> Modifier
                        </button>
                        <dialog id="editrdv" className="modal rounded-none">
                          <div className="relative modal-box w-96">
                            <h1 className="mr-auto text-sm font-semibold font-mtn">
                              Modification la date de rendez-vous
                            </h1>
                            <div className="modal-action">
                              <form
                                method="dialog"
                                className="absolute top-1 right-1"
                              >
                                <button
                                  id="detail"
                                  className="btn btn-sm btn-circle btn-ghost"
                                >
                                  <Cross2Icon />
                                </button>
                              </form>
                            </div>
                            <UpdateRdv item={item} />
                          </div>
                        </dialog>
                      </div>
                    </div>
                  </div>
                ))
              ) : (
                <ContentLoading />
              )}
            </div>
            <div className="my-3 flex justify-end">
              <Pagination
                onChange={(event, newValue) => moreEnAttente(newValue)}
                onSelect={(selectedPage) => moreEnAttente(selectedPage)}
                count={survey?.data?.totalPages}
                variant="outlined"
                color="primary"
                shape="rounded"
              />
            </div>
          </>
        ) : active.index === 1 ? (
          <>
            <div>
              <select
                onChange={(e) =>
                  storeData.getData(
                    LIST_SURVEY,
                    { page: 0, param: "", size: 6 },
                    `&periode=&mois=&annee=&dateDebut=&dateFin=&status=REALISER&resultat=OK&inTime=${e.target.value}`,
                  )
                }
                className="select pl-non my-3"
              >
                <option disabled selected>
                  Delais de traitement
                </option>
                <option value="">Tout afficher</option>{" "}
                <option value={"true"}>Intention dans le delais</option>
                <option value={"false"}>Intention hors delais</option>
              </select>
              <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-3 2xl:grid-cols-3 gap-2 my-4">
                {storeData?.data?.data?.map((item) => (
                  <div
                    className={`${
                      !item?.inTime
                        ? "border-red-300 border-2 border-dashed"
                        : "border-slate-200 border"
                    } relative bg-white rounded-xl  shadow-sm`}
                  >
                    <div className="rounded-t-xl flex items-center gap-3 bg-orange-100 px-2 py-3">
                      <p className="text-[12px] font-semibold">
                        Ticket N°{item?.abonnement?.eligibilite?.numeroTicket}
                      </p>
                      <p className="text-red-500 text-xs">
                        {!item?.inTime ? "Hors delais" : ""}
                      </p>
                    </div>
                    <div className=" px-3 py-2 ">
                      <div className="my-1 flex items-center">
                        <div className="flex items-center gap-2">
                          <Pbo
                            pbo={item?.abonnement?.eligibilite?.pbo?.nom}
                            port={item?.brin}
                          />
                        </div>
                      </div>
                      <div className="items-center gap-2 space-y-3">
                        <div
                          className={`w-fit flex gap-1 px-3 border  rounded-full py-1 text-xs ${
                            item?.status === "EN_ATTENTE"
                              ? "text-orange-600"
                              : item?.status === "En attente"
                                ? "text-gray-500"
                                : "text-green-600"
                          }  font-semibold`}
                        >
                          {item?.status?.toLowerCase().replace(/_/g, " ")}
                          {item.resultat === "OK" ? (
                            <CheckCircledIcon className="ml-auto bg-green-600 w-4 h-4 rounded-full text-white" />
                          ) : item.resultat === "NON_OK" ? (
                            <CrossCircledIcon className="bg-red-600 w-4 h-4 rounded-full text-white" />
                          ) : null}
                        </div>
                        <h1 className="text-[14px] font-bold flex items-center font-mtn">
                          <SewingPinFilledIcon />
                          {item?.abonnement?.commune +
                            ", " +
                            item?.abonnement?.quartier}
                        </h1>
                        <div className="border-dashed border w-fit px-1 py-[2px] bg-green-50 text-green-800 border-green-600 rounded">
                          <p className="text-xs flex gap-1 items-center font-bold">
                            <CalendarIcon /> Réalisé le :{" "}
                            {item.dateCreation
                              ? new Date(item.dateCreation).toLocaleString()
                              : "--"}
                          </p>
                        </div>
                        <h1 className="text-xs flex gap-1 items-center my-2">
                          Forfait : {item?.abonnement?.forfait?.designation} -{" "}
                          {item?.abonnement?.forfait?.categorie
                            ?.replace("_", "")
                            .toLowerCase()}
                        </h1>

                        <div className=" gap-1 ">
                          <div>
                            <p className="text-[13px] font-medium">
                              Numero FTTH : {item?.abonnement?.numeroFtth}
                            </p>
                            <p className="text-xs flex font-semibold gap-2">
                              SN : <span>{item?.abonnement?.numeroSerie}</span>
                            </p>
                          </div>
                        </div>

                        <h1 className="text-xs flex gap-1 items-center my-2">
                          <AvatarIcon />
                          Equipe en charge : {item?.equipe?.designation}
                        </h1>
                        {item?.prestataire?.designation ? (
                          <h1 className="text-xs flex gap-1 p-1 w-fit rounded items-center my-2">
                            Prestataire : {item?.prestataire?.designation}
                          </h1>
                        ) : null}
                        <h1 className="text-xs flex gap-1 items-center my-2">
                          <AvatarIcon />
                          Réaliser par :{" "}
                          {item?.technicien?.nomPrenoms +
                            " | " +
                            item?.technicien?.numero}
                        </h1>
                        {item.resultat === "OK" ? (
                          <div className="dropdown flex items-center">
                            <p className="text-xs">
                              Commentaire: {item?.commentaire}{" "}
                            </p>
                          </div>
                        ) : null}

                        <div className="flex gap-1 ">
                          <PersonIcon className="bg-gray-100 rounded-full w-8 h-8 p-2" />
                          <div>
                            <p className="text-[13px] font-medium">
                              {item?.abonnement?.client?.nomPrenoms}
                            </p>
                            <p className="text-xs flex font-semibold gap-2">
                              <span>{item?.abonnement?.client?.numero}</span>{" "}
                              {" | "}{" "}
                              <span>
                                {item?.abonnement?.client?.secondNumero}
                              </span>{" "}
                            </p>
                          </div>
                        </div>
                        <div className="flex items-center gap-1">
                          {item.resultat === "OK" ? null : checkTagValidity(
                              "MODIFIER_SURVEY",
                            ) ? (
                            <button
                              onClick={() => {
                                setNumeroTicket(
                                  item?.abonnement?.eligibilite?.numeroTicket,
                                );
                                document.getElementById("edit").showModal();
                              }}
                              className="ml-auto text-white text-xs btn btn-sm bg-black"
                            >
                              <Pencil1Icon /> Modifier
                            </button>
                          ) : null}
                          <button
                            onClick={() => {
                              document
                                .getElementById(`show${item.id}`)
                                .showModal();
                            }}
                            className="btn btn-sm bg-main text-xs"
                          >
                            Details du survey
                          </button>

                          {/* <button
                            onClick={() => {
                              setSelectItem(item);
                              document.getElementById("editFtth").showModal();
                            }}
                            className=" text-white text-xs btn btn-sm bg-black"
                          >
                            <Pencil1Icon /> Modifier le numero Ftth
                          </button> */}
                        </div>

                        <dialog
                          id={`show${item.id}`}
                          className="modal bg-slate-900/70"
                        >
                          <div className="modal-box">
                            <div className="flex items-center justify-between p-3">
                              <div className="flex flex-row gap-2">
                                <h2 className="font-extrabold flex flex-row items-center text-xl text-[#000000a8]">
                                  Details du survey
                                </h2>
                              </div>
                              <form method="dialog">
                                <button
                                  id="fermer_create_trajet"
                                  className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-100 hover:bg-red-200 text-red-600 hover:text-red-600 font-semibold"
                                >
                                  ✕
                                </button>
                              </form>
                            </div>
                            <div>
                              <div className="">
                                <div className="bg-white p-3 rounded-lg border">
                                  <div className="px-4 sm:px-0">
                                    <h3 className="lg:text-lg text-2xl text-gray-900 font-bold">
                                      Ticket N°
                                      {
                                        item?.abonnement?.eligibilite
                                          ?.numeroTicket
                                      }
                                    </h3>
                                  </div>
                                  <div className="mt-3 border-t border-gray-100">
                                    <dl className="divide-y divide-gray-100">
                                      <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                        <dt className="text-sm font-semibold text-gray-900">
                                          Client
                                        </dt>
                                        <dd className="mt-1 text-sm font-medium leading-6  sm:col-span-2 sm:mt-0">
                                          {item?.abonnement?.client?.nomPrenoms}
                                        </dd>
                                      </div>

                                      <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                        <dt className="text-sm font-semibold leading-6 text-gray-900">
                                          Email
                                        </dt>
                                        <dd className="mt-1 text-sm font-medium leading-6  sm:col-span-2 sm:mt-0">
                                          {item?.abonnement?.client?.email}
                                        </dd>
                                      </div>
                                      <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                        <dt className="text-sm font-semibold leading-6 text-gray-900">
                                          Contact client
                                        </dt>
                                        <dd className="mt-1 text-sm font-medium leading-6 sm:col-span-2 sm:mt-0">
                                          {item?.abonnement?.client?.numero}
                                        </dd>
                                      </div>
                                      <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                        <dt className="text-sm font-semibold leading-6 text-gray-900">
                                          Numero avantage
                                        </dt>
                                        <dd className="mt-1 text-sm font-medium leading-6 sm:col-span-2 sm:mt-0">
                                          {item?.abonnement?.numeroMtn}
                                        </dd>
                                      </div>
                                      <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                        <dt className="text-sm font-semibold leading-6 text-gray-900">
                                          Ville du client
                                        </dt>
                                        <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                          {
                                            item?.abonnement?.domicile?.quartier
                                              ?.commune?.designation
                                          }
                                        </dd>
                                      </div>
                                      <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                        <dt className="text-sm font-semibold leading-6 text-gray-900">
                                          Quartier
                                        </dt>
                                        <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                          {
                                            item?.abonnement?.domicile?.quartier
                                              ?.designation
                                          }
                                        </dd>
                                      </div>

                                      <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                        <dt className="text-sm font-semibold leading-6 text-gray-900">
                                          Status d'éligibilité
                                        </dt>
                                        <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                          {item?.abonnement?.eligibilite
                                            ?.ftthEligible === "yes"
                                            ? "Eligible"
                                            : "Pas eligible"}
                                        </dd>
                                      </div>

                                      <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                        <dt className="text-sm font-semibold leading-6 text-gray-900">
                                          Forfait souhaité
                                        </dt>
                                        <dd className="mt-1 text-sm leading-6 text-gray-700 sm:col-span-2 sm:mt-0">
                                          {
                                            item?.abonnement?.forfait
                                              ?.designation
                                          }
                                        </dd>
                                      </div>
                                    </dl>
                                  </div>
                                </div>
                              </div>
                              <div className="">
                                <p className="my-4 font-bold text-lg">
                                  Information sur le survey
                                </p>
                                <div className="bg-white p-3 rounded-lg border">
                                  <div className="">
                                    <dl className="divide-y divide-gray-100">
                                      <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                        <dt className="text-sm font-semibold text-gray-900">
                                          Date de rendez-vous
                                        </dt>
                                        <dd className="mt-1 text-sm font-medium leading-6 text-blue-700 sm:col-span-2 sm:mt-0">
                                          {item.dateRdv}
                                        </dd>
                                      </div>

                                      <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                        <dt className="text-sm font-semibold text-gray-900">
                                          Date de réalisation
                                        </dt>
                                        <dd className="mt-1 text-sm font-medium leading-6 text-blue-700 sm:col-span-2 sm:mt-0">
                                          {item?.dateCreation
                                            ? new Date(
                                                item?.dateCreation,
                                              ).toLocaleString()
                                            : "--"}
                                        </dd>
                                      </div>

                                      <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                        <dt className="text-sm font-semibold text-gray-900">
                                          Status du survey
                                        </dt>
                                        <dd className="mt-1 text-sm font-medium leading-6 text-blue-700 sm:col-span-2 sm:mt-0">
                                          {item?.status?.toLocaleLowerCase() ??
                                            "--"}
                                        </dd>
                                      </div>

                                      <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                        <dt className="text-sm font-semibold text-gray-900">
                                          Status de réalisation
                                        </dt>
                                        <dd className="mt-1 text-sm font-medium leading-6 text-blue-700 sm:col-span-2 sm:mt-0">
                                          {item?.resultat.replace("_", " ") ??
                                            "--"}
                                        </dd>
                                      </div>

                                      <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                        <dt className="text-sm font-semibold text-gray-900">
                                          Commentaire
                                        </dt>
                                        <dd className="mt-1 text-sm font-medium leading-6 text-blue-700 sm:col-span-2 sm:mt-0">
                                          {item?.commentaire ?? "--"}
                                        </dd>
                                      </div>

                                      <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                        <dt className="text-sm font-semibold leading-6 text-gray-900">
                                          Créneau horaire
                                        </dt>
                                        <dd className="mt-1 text-sm font-medium leading-6 text-blue-700 sm:col-span-2 sm:mt-0">
                                          {item?.crenau?.heureDebut +
                                            " à " +
                                            item?.crenau?.heureFin}
                                        </dd>
                                      </div>
                                      <div className="px-4 py-3 sm:grid sm:grid-cols-3 sm:gap-4 sm:px-0">
                                        <dt className="text-sm font-semibold leading-6 text-gray-900">
                                          Equipe en charge
                                        </dt>
                                        <dd className="mt-1 text-sm font-medium leading-6 text-blue-700 sm:col-span-2 sm:mt-0">
                                          {item?.equipe?.designation}
                                        </dd>
                                      </div>
                                    </dl>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </dialog>
                      </div>
                    </div>
                  </div>
                ))}
              </div>
            </div>
            <dialog id="edit" className="modal ">
              <div className="modal-box">
                <div className="modal-action">
                  <h1 className="mr-auto text-2xl font-bold font-mtn">
                    Modification de l'abonnement
                  </h1>
                  <form method="dialog">
                    <button
                      id="fermer"
                      className="w-8 h-8 flex items-center justify-center rounded-lg bg-red-100 hover:bg-red-200 text-red-600 hover:text-red-600 font-semibold"
                    >
                      ✕
                    </button>
                  </form>
                </div>
                <UpdateSurvey
                  numeroTicket={numeroTicket}
                  setActive={setActive}
                />
              </div>
            </dialog>
            <div className="my-3 flex justify-end">
              <Pagination
                onChange={(event, newValue) => more(newValue)}
                onSelect={(selectedPage) => more(selectedPage)}
                count={storeData?.data?.totalPages}
                variant="outlined"
                color="primary"
                shape="rounded"
              />
            </div>
          </>
        ) : null}
      </div>
    </div>
  );
};

export default Survey;
